import swal from 'sweetalert';
import { csrfToken } from 'rails-ujs';

$(() => {
  $('#extend_invite').on('click', (event) => {
    event.preventDefault();

    const url = $('#extend_invite').data('url');

    swal({
      title: "招待枠を追加します。",
      text: "追加時に1枠3,000円（税別）の追加料金が発生します。",
      icon: "warning",
      buttons: {
        cancel: {
          text: "追加しない",
          visible: true,
          value: false,
          closeModal: true
        },
        confirm: {
          text: "追加する",
          visible: true,
          value: true,
          closeModal: false
        }
      },
      dangerMode: true
    })
    .then((extend) => {
      if (extend) {
        $.ajax({
          type: 'POST',
          url: url,
          headers: {
            'X-CSRF-Token': csrfToken()
          }
        }).done(() => {
          location.reload();
        }).fail(() => {
          swal.stopLoading();
        });
      }
    });
  });
});
